VjsUtility.Notification.addHook((text, time, type) => {
    const notificationOptions = {
        text: text.body ? text.body : text,
        type,
        delay: time,
        title: text.title ? text.title : type,
    };

    // there isn't a warning method in pnotify so we are mapping warning to notice here.
    let noticeType;
    if (type === 'warning') {
        noticeType = 'notice';
    } else if (['success', 'error', 'info'].includes(type)) {
        noticeType = type;
    } else {
        noticeType = 'notice';
    }
    PNotify[noticeType](notificationOptions);
});
